import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

interface EditUsedAssemblyMaterialType {
  uuid: string;
  count: number;
}

const useEditUsedAssemblyMaterial = (
  options?: UseMutationOptions<any, Error, EditUsedAssemblyMaterialType>
) => {
  return useMutation({
    ...options,
    mutationKey: ['editUsedAssemblyMaterial'],
    mutationFn: async ({ uuid, count }) => {
      return axiosInstance.put(`/assembly-materials/used/${uuid}`, {
        count,
      }).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie edycji materiału...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'edit-used-assembly-material',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Materiał został pomyślnie zaktualizowany',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'edit-used-assembly-material',
      });
      queryClient.invalidateQueries({ queryKey: ['orderDetails'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas edycji materiału',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'edit-used-assembly-material',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useEditUsedAssemblyMaterial;
